import tinycolor from 'tinycolor2';
import { unref } from 'vue';
import { colors } from '../component-lib.esm2.js';

/**
 * Parse various strings (e.g. 'primary', 'secondary)
 * into an actual color.
 */
function getThemeColor(color, theme) {
  let themeColors = unref(theme).colors;
  if (color.startsWith('gray') && color.length === 7) return themeColors[color];
  switch (color) {
    case 'primary':
      return themeColors.primary;
    case 'secondary':
      return themeColors.secondary;
    case 'current':
      return 'currentColor';
    case 'on-bg':
      return themeColors.onBg;
    case 'error':
      return themeColors.error;
    case 'success':
      return themeColors.success;
    case 'info':
      return themeColors.info;
    default:
      // Assume color is a string representing a color
      return color;
  }
}
function getTextColor(color, theme) {
  let themeColors = unref(theme).colors;
  switch (color) {
    case 'primary':
      return themeColors.onPrimary;
    case 'secondary':
      return themeColors.onSecondary;
    case 'current':
      return 'currentColor';
    case 'error':
      return colors.white;
    case 'success':
      return colors.white;
    case 'info':
      return colors.black;
    default:
      // eslint-disable-next-line no-case-declarations
      let currentColor = color;
      if (color.startsWith('gray') && color.length === 7) {
        currentColor = themeColors[color];
      }
      // Assume color is a string representing a color
      // eslint-disable-next-line no-case-declarations
      let isDark = tinycolor(currentColor).isDark();
      return isDark ? colors.white : colors.black;
  }
}

/**
 * Get an appropriately contrasting text color
 * when the `color` prop is used as a background
 * color
 */
function getThemeTextColor(color, theme) {
  return getTextColor(color, theme);
}

/**
 * Lighten or darken `props.color` as is suitable for
 * hover or focus states.
 * @param props The theme props
 * @param level The amount of change to make to the color, 0, 1, or 2
 * @param invert
 */
function getThemeAccentColor(_ref) {
  let {
    color,
    theme,
    isFilled
  } = _ref;
  let {
    level = 0
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const alphas = {
    standard: [0.1, 0.3, 0.5],
    highLightness: [0.2, 0.4, 0.6],
    filled: [0.8, 0.6, 0.4]
  };
  let bg = getThemeColor(color, theme);
  let colorInfo = tinycolor(bg);
  let isDark = colorInfo.isDark();
  let alphaLevels = isFilled ? alphas.filled : colorInfo.getLuminance() > 0.6 ? alphas.highLightness : alphas.standard;

  // For filled items with a light color, darken the color
  // instead of decreasing the opacity
  if (!isDark && isFilled) {
    const darkenLevels = [5, 12, 17];
    return colorInfo.darken(darkenLevels[level]).toRgbString();
  }
  return colorInfo.setAlpha(alphaLevels[level]).toRgbString();
}
export { getTextColor, getThemeAccentColor, getThemeColor, getThemeTextColor };